module.exports = __webpack_public_path__ + "octopus-service-440.186e27b6d30700fbab8955ba3a7fb86d.hashedasset.svg";